import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FA3737",
      "fill-rule": "evenodd",
      d: "M7.813.314a2.4 2.4 0 0 1 2.373 0c.363.206.669.504.886.866l.003.004 6.598 11.122a2.49 2.49 0 0 1 .007 2.455c-.211.374-.514.684-.88.9a2.4 2.4 0 0 1-1.2.339H2.4a2.4 2.4 0 0 1-1.2-.338 2.44 2.44 0 0 1-.88-.9 2.49 2.49 0 0 1 .007-2.456l.007-.012L6.927 1.18c.218-.362.523-.66.886-.866M9 1.778a.69.69 0 0 0-.587.33l-.001.002-6.583 11.097a.68.68 0 0 0 .586 1.015h13.17a.687.687 0 0 0 .673-.684c0-.116-.03-.23-.087-.331L9.588 2.11l-.002-.002A.68.68 0 0 0 9 1.778m.047 2.962a.88.88 0 0 1 .87.89v3.16a.88.88 0 0 1-.87.889.88.88 0 0 1-.871-.89V5.63c0-.49.39-.889.87-.889m-.871 7.21c0-.49.39-.888.87-.888h.008a.88.88 0 0 1 .871.889.88.88 0 0 1-.87.888h-.008a.88.88 0 0 1-.871-.889",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }